import React from 'react';
import { Link } from 'react-router-dom';
import {
  BookOpen,
  Code2,
  MessageSquare,
  Mail,
  Github,
  ExternalLink
} from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-black">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo and Description */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              {/* If you have a white logo version, use it here, otherwise text is safer for now */}
              <div>
                <h3 className="font-heading font-bold text-2xl text-white">
                  Igreja de Jardim
                </h3>
                <p className="text-xs text-church-green uppercase tracking-widest font-semibold mt-1">Estudos Bíblicos</p>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed font-sans">
              Plataforma dedicada ao crescimento espiritual através do estudo profundo da Palavra de Deus.
            </p>
          </div>

          {/* Sobre Column */}
          <div className="space-y-6">
            <h4 className="font-semibold text-white flex items-center gap-2">
              <BookOpen className="h-4 w-4 text-church-green" />
              Sobre
            </h4>
            <nav className="space-y-3">
              <Link
                to="/sobre"
                className="block text-sm text-gray-400 hover:text-church-green transition-colors"
              >
                Sobre o Projeto
              </Link>
              <Link
                to="/sobre#recursos"
                className="block text-sm text-gray-400 hover:text-church-green transition-colors"
              >
                Como Funciona
              </Link>
              <Link
                to="/sobre#recursos"
                className="block text-sm text-gray-400 hover:text-church-green transition-colors"
              >
                Recursos
              </Link>
            </nav>
          </div>

          {/* Suporte Column */}
          <div className="space-y-6">
            <h4 className="font-semibold text-white flex items-center gap-2">
              <MessageSquare className="h-4 w-4 text-church-green" />
              Suporte
            </h4>
            <nav className="space-y-3">
              <Link
                to="/contato"
                className="block text-sm text-gray-400 hover:text-church-green transition-colors"
              >
                Reportar Problema
              </Link>
              <Link
                to="/contato#sugestoes"
                className="block text-sm text-gray-400 hover:text-church-green transition-colors"
              >
                Sugestões
              </Link>
              <a
                href="mailto:brunorodrigotubio@gmail.com"
                className="block text-sm text-gray-400 hover:text-church-green transition-colors flex items-center gap-1"
              >
                <Mail className="h-3 w-3" />
                Contato Direto
              </a>
            </nav>
          </div>

          {/* Técnico Column */}
          <div className="space-y-6">
            <h4 className="font-semibold text-white flex items-center gap-2">
              <Code2 className="h-4 w-4 text-church-green" />
              Técnico
            </h4>
            <nav className="space-y-3">
              <Link
                to="/documentacao"
                className="block text-sm text-gray-400 hover:text-church-green transition-colors"
              >
                Documentação
              </Link>
              <Link
                to="/documentacao#arquitetura"
                className="block text-sm text-gray-400 hover:text-church-green transition-colors"
              >
                Arquitetura
              </Link>
              <Link
                to="/documentacao#stack"
                className="block text-sm text-gray-400 hover:text-church-green transition-colors"
              >
                Stack Técnica
              </Link>
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-sm text-gray-400 hover:text-church-green transition-colors flex items-center gap-1"
              >
                <Github className="h-3 w-3" />
                Código Fonte
                <ExternalLink className="h-3 w-3" />
              </a>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © 2025 Igreja de Jardim.
            </p>
            <div className="flex items-center gap-4 text-xs text-gray-600">
              <span>Feito com Propósito</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;